import { Badge, Icon, SvgFile } from '@tmapy/style-guide';

export type BadgeType = 'info' | 'success' | 'danger' | 'warning';

const EXT_TYPE: Record<string, BadgeType> = {
  pdf: 'danger',
  zip: 'warning',
  dgn: 'info',
  xml: 'warning',
  txt: 'info',
  log: 'info',
  json: 'success',
};

export function extBadgeType(ext: string): BadgeType {
  return EXT_TYPE[ext.toLowerCase()] ?? 'info';
}

export function FileIconWithBadge({ name, ext }: { name?: string; ext?: string }) {
  const resolvedExt = ext ?? name?.split('.').pop();
  return (
    <span className='dmx-fileIcon'>
      <Icon element={<SvgFile />} size="sml" />
      {resolvedExt && (
        <Badge type={extBadgeType(resolvedExt)}>{resolvedExt.toUpperCase()}</Badge>
      )}
    </span>
  );
}
